import { render, staticRenderFns } from "./IncomingCall.vue?vue&type=template&id=1c7861d4&scoped=true"
import script from "./IncomingCall.vue?vue&type=script&lang=js"
export * from "./IncomingCall.vue?vue&type=script&lang=js"
import style0 from "./IncomingCall.vue?vue&type=style&index=0&id=1c7861d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7861d4",
  null
  
)

export default component.exports